// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FxKN","col":"styles_col__ztQko"};